// One filter bar for the whole board (issue #749).
//
// Board-wide rather than per-lane, because a case moves: filter the Assigned
// lane for Haugesund and the filter stops applying the moment the unit is
// received. The question people actually ask -- "what is happening with
// Haugesund", "where are the Vard Electro units" -- spans the lanes by nature.

import React from 'react';
import { colors } from '../theme';
import { hasActiveFilter } from '../utils/rmaTags';

const barStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  flexWrap: 'wrap',
  padding: '0.6rem 0',
  flexShrink: 0,
};

const controlStyle = {
  background: 'rgba(255,255,255,0.05)',
  border: `1px solid ${colors.panelBorder}`,
  borderRadius: 8,
  color: colors.textStrong,
  fontSize: '0.82rem',
  padding: '0.35rem 0.55rem',
};

export default function RmaBoardFilters({ filters, onChange, options, matching, total }) {
  const active = hasActiveFilter(filters);
  const set = patch => onChange({ ...filters, ...patch });

  return (
    <div style={barStyle}>
      <input
        type="search"
        value={filters.search}
        onChange={e => set({ search: e.target.value })}
        placeholder="Search RMA, serial or customer…"
        aria-label="Search the board"
        style={{ ...controlStyle, flex: '1 1 220px', minWidth: 0 }}
      />

      <select
        value={filters.location}
        onChange={e => set({ location: e.target.value })}
        aria-label="Filter by location"
        style={controlStyle}
      >
        <option value="">All locations</option>
        {options.locations.map(o => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>

      <select
        value={filters.customer}
        onChange={e => set({ customer: e.target.value })}
        aria-label="Filter by customer"
        style={controlStyle}
      >
        <option value="">All customers</option>
        {options.customers.map(o => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>

      {active && (
        <>
          <span style={{ fontSize: '0.78rem', color: colors.textMuted }}>
            {matching} of {total} cases
          </span>
          <button
            type="button"
            onClick={() => set({ location: '', customer: '', search: '' })}
            className="ni-button ni-button--ghost"
            style={{ fontSize: '0.75rem', padding: '0.25rem 0.6rem' }}
          >
            Clear
          </button>
        </>
      )}
    </div>
  );
}
